"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/index.ts
var src_exports = {};
__export(src_exports, {
  MelwaysProvider: () => MelwaysProvider,
  useMelwaysInfo: () => useMelwaysInfo,
  useMelwaysLink: () => useMelwaysLink
});
module.exports = __toCommonJS(src_exports);

// ../../private/common-types/src/non-standard-homepage-hack.ts
var isNonStandardHomepageLanguageSite = (site) => site in nonStandardHomepageDefaultLanguages;
var nonStandardHomepageDefaultLanguages = {
  "candidate-jobsdb-th": "th",
  "candidate-jobstreet-id": "id"
};

// ../../private/router-utils/src/get-lang-from-path.ts
var getLanguageFromPath = ({
  path,
  languages,
  site
}) => {
  if (path === "/" && isNonStandardHomepageLanguageSite(site)) {
    return {
      language: nonStandardHomepageDefaultLanguages[site],
      pathWithoutLanguage: "/"
    };
  }
  if (path === "/" || path.indexOf("/") !== 0 || !languages) {
    return {
      pathWithoutLanguage: path
    };
  }
  const secondSlashIndex = path.indexOf("/", 1);
  const possibleLanguage = secondSlashIndex === -1 ? path.slice(1) : path.slice(1, path.indexOf("/", 1));
  if (languages.indexOf(possibleLanguage) === -1) {
    return {
      pathWithoutLanguage: path
    };
  }
  return {
    language: possibleLanguage,
    pathWithoutLanguage: secondSlashIndex === -1 ? "/" : path.slice(secondSlashIndex)
  };
};

// ../../private/router-utils/src/parse-url.ts
var import_melways_sites = require("@seek/melways-sites");
var ensureUrlObject = (url, hostname) => {
  if (url instanceof URL) {
    return url;
  }
  try {
    const base = hostname ? `https://${hostname}` : void 0;
    return new URL(url, base);
  } catch (e) {
    if (e instanceof Error && e.message.includes("is not a valid URL") && url.startsWith("/") && !hostname) {
      throw new Error(
        "parseUrl needs a full URL including domain. Relative paths are not accepted."
      );
    }
    throw e;
  }
};
var parseUrlWithSite = ({
  url,
  site,
  staging = false
}) => {
  const hostname = (0, import_melways_sites.getHostName)({ site, staging });
  const inputUrl = ensureUrlObject(url, hostname);
  return {
    ...getMelwaysContextFromParsedValues({
      pathName: inputUrl.pathname,
      site
    }),
    staging,
    url: inputUrl,
    hostname
  };
};
var getMelwaysContextFromParsedValues = ({
  site,
  pathName
}) => {
  const config = import_melways_sites.siteConfig[site];
  const { language = "en", pathWithoutLanguage } = getLanguageFromPath({
    path: pathName,
    languages: config.languages,
    site
  });
  const locale = (0, import_melways_sites.getLocale)(site, language);
  return {
    site,
    language,
    locale,
    pathWithoutLanguage,
    classification: config.classification
  };
};

// src/providers/client.tsx
var import_melways_sites2 = require("@seek/melways-sites");
var import_react2 = __toESM(require("react"));

// src/context.ts
var import_react = require("react");
var MelwaysContext = (0, import_react.createContext)(null);

// src/providers/client.tsx
var MelwaysClientProvider = ({
  site,
  staging = false,
  alternative,
  children,
  path
}) => {
  if (!window) {
    throw new Error(
      "MelwaysClientProvider must be used on the client side only"
    );
  }
  if (!(0, import_melways_sites2.isMelwaysSiteName)(site)) {
    throw new Error("MelwaysClientProvider requires a valid site name.");
  }
  const url = path || window.location.href;
  const value = (0, import_react2.useMemo)(() => {
    const { classification, ...rest } = parseUrlWithSite({
      url,
      site,
      staging
    });
    return {
      ...rest,
      ...classification,
      ...alternative ? { alternative } : {}
    };
  }, [site, staging, alternative, url]);
  return /* @__PURE__ */ import_react2.default.createElement(MelwaysContext.Provider, { value }, children);
};

// src/providers/server.tsx
var import_melways_sites3 = require("@seek/melways-sites");
var import_react3 = __toESM(require("react"));
var MelwaysServerProvider = ({
  url,
  site,
  staging = false,
  alternative,
  children
}) => {
  if (!(0, import_melways_sites3.isMelwaysSiteName)(site)) {
    throw new Error("MelwaysServerProvider requires a valid site name.");
  }
  const contextValue = (0, import_react3.useMemo)(() => {
    const { classification, ...rest } = parseUrlWithSite({
      url,
      site,
      staging
    });
    return {
      ...rest,
      ...classification,
      ...alternative ? { alternative } : {}
    };
  }, [url, site, staging, alternative]);
  return /* @__PURE__ */ import_react3.default.createElement(MelwaysContext.Provider, { value: contextValue }, children);
};

// src/providers/static.tsx
var import_melways_sites4 = require("@seek/melways-sites");
var import_react4 = __toESM(require("react"));
var MelwaysStaticProvider = ({
  site,
  staging = false,
  language: languageProp,
  path,
  alternative,
  children
}) => {
  const contextValue = (0, import_react4.useMemo)(() => {
    const language = (0, import_melways_sites4.getLanguageFromLocale)(languageProp);
    const locale = (0, import_melways_sites4.getLocale)(site, language);
    const classification = (0, import_melways_sites4.getClassificationFromSiteName)(site);
    return {
      site,
      staging,
      language,
      pathWithoutLanguage: path,
      hostname: (0, import_melways_sites4.getHostName)({ site, staging }),
      locale,
      ...classification,
      ...alternative ? { alternative } : {}
    };
  }, [site, staging, languageProp, path, alternative]);
  return /* @__PURE__ */ import_react4.default.createElement(MelwaysContext.Provider, { value: contextValue }, children);
};

// src/hooks.tsx
var import_melways_sites5 = require("@seek/melways-sites");
var import_react5 = require("react");
var useMelwaysInfo = () => {
  const melwaysContext = (0, import_react5.useContext)(MelwaysContext);
  if (melwaysContext === null) {
    throw new Error("useMelwaysInfo must be used within a MelwaysProvider");
  }
  return melwaysContext;
};
function useMelwaysLink(linkProps) {
  const melwaysInfo = useMelwaysInfo();
  const urlResolver = (0, import_melways_sites5.createUrlResolver)(melwaysInfo);
  if (!linkProps) {
    return urlResolver;
  }
  const urlStringResolver = (link) => {
    const linkToResolve = typeof link === "string" ? { path: link } : link;
    return urlResolver(linkToResolve);
  };
  if (Array.isArray(linkProps)) {
    return linkProps.map(urlStringResolver);
  }
  return urlStringResolver(linkProps);
}

// src/index.ts
var MelwaysProvider = {
  Client: MelwaysClientProvider,
  Server: MelwaysServerProvider,
  Static: MelwaysStaticProvider
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MelwaysProvider,
  useMelwaysInfo,
  useMelwaysLink
});
//# sourceMappingURL=index.js.map